import { ref } from 'vue';

const storedCredentials = localStorage.getItem('user_credentials');
let initialCredentials = null;
try {
  initialCredentials = storedCredentials ? JSON.parse(storedCredentials) : null;
} catch {
  localStorage.removeItem('user_credentials');
}
const credentialsState = ref(initialCredentials);

// Save token to localStorage
export function saveToken(token) {
  localStorage.setItem('user_token', token);
}

// Get token from localStorage
export function getToken() {
  return localStorage.getItem('user_token');
}

// Remove token from localStorage
export function removeToken() {
  localStorage.removeItem('user_token');
}

// Save credentials to localStorage
export function saveCredentials(credentials) {
  localStorage.setItem('user_credentials', JSON.stringify(credentials));
  credentialsState.value = credentials;
}

// Get credentials from localStorage
export function getCredentials() {
  return credentialsState.value;
}

// Remove credentials from localStorage
export function removeCredentials() {
  localStorage.removeItem('user_credentials');
  credentialsState.value = null;
}
